/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Cli_TitleInputs */

const en_pc_tut_cli_title = /** @type {(inputs: Pc_Tut_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate with the command line`)
};

const zh_pc_tut_cli_title = /** @type {(inputs: Pc_Tut_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用命令行自动化`)
};

/**
* | output |
* | --- |
* | "Automate with the command line" |
*
* @param {Pc_Tut_Cli_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_cli_title = /** @type {((inputs?: Pc_Tut_Cli_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Cli_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_cli_title(inputs)
	return zh_pc_tut_cli_title(inputs)
});
export { pc_tut_cli_title as "pc.tut.cli.title" }